// Customizable Area Start
import React, { Component } from "react";
import { styled } from "@mui/material/styles";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

type ButtonTypes = "contained" | "filled" | "green";

interface Props extends ButtonProps {
  children: React.ReactNode;
  customVariant: ButtonTypes;
  isLoading?: boolean;
  loaderSize?: number;
}

const CustomButtonComponent = styled(Button, {
  shouldForwardProp: (prop) => prop !== "customVariant",
})(({ customVariant }: { customVariant: ButtonTypes }) => ({
  borderRadius: "32px",
  padding: "10.5px 16px",
  fontSize: "1rem",
  minWidth: "110px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  lineHeight: "normal",
  ...(customVariant === "filled" && {
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    color: "#fff",
    padding: "12.5px 18px",
    "& svg": {
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#5a0c91",
      opacity: 0.95,
    },
    "&.Mui-disabled": {
      color: "#fff",
      opacity: 0.25,
    },
  }),
  ...(customVariant === "contained" && {
    backgroundColor: "#fff",
    color: "#652784",
    border: "2px solid #6a0dad",
    "& svg": {
      color: "#652784",
    },
    "&:hover": {
      backgroundColor: "#f0eafb",
      opacity: 0.95,
    },
    "&.Mui-disabled": {
      color: "#652784",
      opacity: 0.25,
    },
  }),
  ...(customVariant === "green" && {
    backgroundColor: "#059669",
    color: "#fff",
    "& svg": {
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#059669",
      opacity: 0.95,
    },
    "&.Mui-disabled": {
      color: "#fff",
      opacity: 0.25,
    },
  }),
}));

class CustomButton extends Component<Props> {
  render() {
    const {
      children,
      disabled,
      customVariant,
      isLoading,
      loaderSize = 20,
      ...rest
    } = this.props;

    return (
      <CustomButtonComponent
        disabled={disabled || isLoading}
        customVariant={customVariant}
        {...rest}
      >
        {isLoading ? <CircularProgress size={loaderSize} /> : children}
      </CustomButtonComponent>
    );
  }
}

export default CustomButton;
// Customizable Area End
